function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zM16 .8C7.6.8.8 7.6.8 16S7.6 31.2 16 31.2 31.2 24.4 31.2 16C31.2 7.6 24.4.8 16 .8z" /><path d="M9.5 21.8L21.8 9.5c.1-.1.2-.1.3 0l.4.4c.1.1.1.2 0 .3L10.2 22.5c-.1.1-.2.1-.3 0l-.4-.4c-.1 0-.1-.2 0-.3z" /><path d="M21.8 22.5L9.5 10.2c-.1-.1-.1-.2 0-.3l.4-.4c.1-.1.2-.1.3 0l12.4 12.4c.1.1.1.2 0 .3l-.4.4c-.1 0-.3 0-.4-.1z" /></svg>;
});